export const login = '/'

export const home = '/'
export const packagesDeliveryChart = '/packages-delivery-chart'
export const trackCodesChart = '/track-codes-chart'
